import React from 'react';
import './SignUpInviteForm.css';
import '../selectize/Selectize.css';
import { sendEmail } from '../../../firebase/api/mail';
import { Form } from 'reactstrap';
import { getAuthUser } from '../../../static/localStorage';
import Button from '../../button';
import Multiselect from '../multiselect';
import { getInviteToAnswerTemplate } from '../../../templates';

class SignUpInviteForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            userMessage: '',
        };
    }

    get isSendButtonDisabled() {
        return !this.state.users.length;
    }

    onInputChange = (options, values, search) => {
        let labels = values.map(function (value) {
            return value.label;
        });
        if (search.trim().length === 0 || labels.indexOf(search.trim()) !== -1) return null;
        return { label: search.trim(), value: search.trim() };
    };

    handleNoteChange = e => {
        const { value } = e.target;

        this.setState({ userMessage: value });
    };

    handleSendButtonClick = () => {
        const mails = this.state.users.map(email => {
            return email.value;
        });
        const currentUser = getAuthUser();
        sendEmail(
            getInviteToAnswerTemplate(
                mails,
                currentUser.firstName,
                this.state.userMessage,
                `${window.location.origin}?invitationKey=${this.props.inviteCode}`
            )
        );
        this.props.toggle();
    };

    handleValueChange = value => {
        this.setState({
            users: value.filter(v => v.value.length !== 0),
        });
    };

    render() {
        return (
            <Form name="sign-up-invite-form" className="signUpInviteForm">
                <div className="d-flex flex-column">
                    <div className="d-flex invite-friends__descriptions mb-2">
                        (Please separate emails with either a comma or tap space bar.)
                    </div>
                    <div className="d-flex">
                        <div className="mr-3">
                            <Multiselect
                                placeholder="Add email"
                                className="invite-friends__select"
                                onChange={this.handleValueChange}
                            />
                        </div>
                        <Button
                            text="Send"
                            onClick={this.handleSendButtonClick}
                            isDisabled={this.isSendButtonDisabled}
                            classes="invite-friends__send-button"
                        />
                    </div>
                    <div className="d-flex mt-3">
                        <textarea
                            className="invite-friends__note p-2"
                            placeholder="Add a note..."
                            value={this.state.userMessage}
                            onChange={this.handleNoteChange}
                        />
                    </div>
                </div>
            </Form>
        );
    }
}

export default SignUpInviteForm;
